module.exports = __webpack_public_path__ + "img/6.f306ca5d.png";